export enum TableColumeType {
  Boolean,
  Int,
  String,
  Number,
  Dropdown,
  Date
}